export default __webpack_public_path__ + "static/media/empty-answers.86bc6e78.svg";